import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

const get = async ({ email }: { email: string }) => {
  try {
    const url = endpoints.employee.miniProfileFromEmail;
    const res = await sendRequest({
      url,
      method: 'GET',
      credentials: 'include',
      queryParams: {
        email,
      },
    });
    return res.entity;
  } catch (error) {
    console.error('Error while fetching mini profile data ', error);
    throw new Error(error);
  }
};

export const useGetMiniProfileFromEmail = ({ email }: { email: string }) =>
  useQuery([REACT_QUERY_KEYS.miniProfileFromEmail, email], () => get({ email }), { enabled: !!email });
